/**
 * Created by Jasper on 10/03/2021.
 */

import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
}) export class PrintService {

    constructor() {}


    public printMap() {
        const body = document.body;
        const mapContainer = document.querySelector('.map-component-container');
        if (!mapContainer) return false;

        const mapContainerParent = mapContainer.parentElement;

        // Print container maken
        const printContainer = document.createElement('div');
        Object.assign(printContainer.style, {
            position: 'relative',
            width: '100%',
            maxWidth: '1920px',
            height: `${(mapContainer as HTMLElement).offsetHeight}px`
        });

        // Map container verplaatsen naar printContainer en printContainer naar body
        printContainer.appendChild(mapContainer);
        body.prepend(printContainer);

        // Alles behalve printContainer en scripts tijdelijk verwijderen
        const detachedElements: HTMLElement[] = [];
        Array.from(body.children).forEach(child => {
            if (child !== printContainer && child.tagName.toLowerCase() !== 'script') {
                detachedElements.push(child as HTMLElement);
                child.remove();
            }
        });

        // Print-specifieke CSS toevoegen
        const patchedStyle = document.createElement('style');
        patchedStyle.media = 'print';
        patchedStyle.textContent = `
        img { max-width: none !important; }
        a[href]:after { content: ""; }
    `;
        document.head.appendChild(patchedStyle);

        // Printen
        window.focus();
        window.print();

        // Alles terugplaatsen
        detachedElements.forEach(el => body.prepend(el));
        mapContainerParent.prepend(mapContainer);

        // Print container en style verwijderen
        printContainer.remove();
        patchedStyle.remove();

        return false;
    }

    public printManual(htmlToPrint: string) {
        const downloadButton = document.getElementById('print-btn');

        const printElement = document.createElement('div');
        printElement.id = 'manual-print-container';
        printElement.innerHTML = htmlToPrint;

        document.body.style.background = '#FFFFFF';
        if (downloadButton) downloadButton.style.display = 'none';
        document.body.appendChild(printElement);

        setTimeout(() => {
            window.print();

            window.onfocus = () => {
                document.body.style.background = '#f5f5f5';
                if (downloadButton) downloadButton.style.display = 'block';
                printElement.remove();
            };
        });
    }
}
